import { render, staticRenderFns } from "./ServeCenterDetail.vue?vue&type=template&id=1c46f593&scoped=true&"
import script from "./ServeCenterDetail.vue?vue&type=script&lang=js&"
export * from "./ServeCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServeCenterDetail.vue?vue&type=style&index=0&id=1c46f593&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c46f593",
  null
  
)

export default component.exports